<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">View/Edit Waste Drums</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">

      <aims-common-table
        id="drums-table"
        [dataSource]="drums | async"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        pageSize="10"
        [stickyHeader]="true">

        <ng-template aimsCommonTableDynamicToolbar>
          <aims-common-button aria-label="Add" (click)="handleRowAdd()">
            <mat-icon>add</mat-icon>
            Add
          </aims-common-button>
        </ng-template>

        <aims-common-table-dynamic-row id="containerTypeId">
          <ng-template viewMode let-element >
            {{ element.containerTypeId | getText:'containerTypeId':'containerTypeDescription':wasteContainerTypes | async }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let c of wasteContainerTypes | async " [value]="c.containerTypeId">
                  {{ c.containerTypeDescription }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="wasteTypeId">
          <ng-template viewMode let-element >
            {{ element.wasteTypeId | getText:'wasteTypeId':'wasteType':wasteTypes | async }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let w of wasteTypes | async " [value]="w.wasteTypeId">
                  {{ w.wasteType }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="siteId">
          <ng-template viewMode let-element >
            {{ element.siteId | getText:'siteId':'siteName':sites }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let s of sites" [value]="s.siteId">
                  {{ s.siteName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="issuedById">
          <ng-template viewMode let-element >
            {{ element.issuedById | getText:'employeeId':'fullName':emps }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of emps" [value]="e.employeeId">
                  {{ e.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="wasteCurrentStatusId">
          <ng-template viewMode let-element >
            {{ element.wasteCurrentStatusId | getText:'wasteCurrentStatusId':'wasteCurrentStatus':wasteStati | async }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let w of wasteStati  | async" [value]="w.wasteCurrentStatusId">
                  {{ w.wasteCurrentStatus }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="sealedById">
          <ng-template viewMode let-element >
            {{ element.sealedById | getText:'employeeId':'fullName':emps }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of emps" [value]="e.employeeId">
                  {{ e.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="closedOutById">
          <ng-template viewMode let-element >
            {{ element.closedOutById | getText:'employeeId':'fullName':emps }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of emps" [value]="e.employeeId">
                  {{ e.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>

    </div>
  </div>


  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
